<template>
  <BaseDialog
    :ref="name"
    width="lg"
    height="fixed"
    mobile-height="full"
    :name="name"
    class="review-dialog"
    :title-header="title"
  >
    <template #body>
      <div class="mt-4">
        <TeacherListReviewContent />
      </div>
    </template>
  </BaseDialog>
</template>

<script>
import { mapGetters } from 'vuex'
import TeacherListReviewContent from './teacher-list-review-content'
export default {
  name: 'TeacherListReviewDialog',
  components: { TeacherListReviewContent },
  props: {
    name: {
      type: String,
      default: ''
    },
    item: {
      type: Object,
      default: () => {
      }
    }
  },
  computed: {
    ...mapGetters('teacher', ['getSelectedTeacher']),
    title () {
      return this.$t('common.titles.review_dialog', { name: this.getSelectedTeacher?.fullName })
    }
  }
}
</script>
